import React, { Suspense } from 'react';
import lazyWithRetry from 'utils/lazyWithRetry';
import Login from 'pages/login/Login';
import NotFound from 'components/404';
import Loader from 'wrapper/loader';

const BorrowerProfile = lazyWithRetry(() => import('pages/borrower-profile-officer'));
const PipelineAdmin = lazyWithRetry(() => import('pages/pipeline-officer'));
const Dashboard = lazyWithRetry(() => import('pages/dashboard-officer'));
const Tools = lazyWithRetry(() => import('pages/tools-officer'));
const QuickPrice = lazyWithRetry(() => import('pages/quickPrice-officer'));
const Reports = lazyWithRetry(() => import('pages/reports-admin/reports'));
const EmployeeOnboard = lazyWithRetry(() => import('pages/auth/EmployeeOnboard'));
const UserManagement = lazyWithRetry(() => import('pages/user-management-officer'));

const officerRoutes = [
  {
    path: '/',
    element: <Login />,
    children: [
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Dashboard />
          </Suspense>
        ),
        children: [],
      },
      {
        path: ':param/lead',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <BorrowerProfile />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <PipelineAdmin />
          </Suspense>
        ),
      },
      {
        path: 'onboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <EmployeeOnboard />
          </Suspense>
        ),
      },
      {
        path: 'tools',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Tools />
          </Suspense>
        ),
      },
      {
        path: 'quickPrice',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <QuickPrice />
          </Suspense>
        ),
      },
      {
        path: 'reports',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Reports />
          </Suspense>
        ),
      },
      {
        path: 'user-management',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <UserManagement />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default officerRoutes;
